import { render, staticRenderFns } from "./SurveyPage.vue?vue&type=template&id=22aaf74a"
import script from "./SurveyPage.vue?vue&type=script&lang=js"
export * from "./SurveyPage.vue?vue&type=script&lang=js"
import style0 from "./SurveyPage.vue?vue&type=style&index=0&id=22aaf74a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports